import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'zeudy-business-skin',
  styleUrl: 'zeudy-business-skin.scss',
  shadow: false,
})
export class zeudyBusinessSkin {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
